/*
  In order to be able to run gc() from javascript you need to run
  a separate instance of chrome with some flags enabled

  Below is a copy-paste formula to run in terminal under MacOS

  /Applications/Google\ Chrome.app/Contents/MacOS/Google\ Chrome --js-flags="--expose-gc" --remote-debugging-port=9222 --user-data-dir=$TMPDIR/chrome-profiling --no-default-browser-check
*/

import angular from 'angular';

const timer = (time) => new Promise((resolve) => setTimeout(resolve, time));
window.leaktest = function leaktest(testingStateArg) {
  const $state = angular.element(document.documentElement).injector().get('$state');
  const $rootScope = angular.element(document.documentElement).injector().get('$rootScope');

  let testingState = testingStateArg;
  if (!testingState) {
    testingState = $state.current.name;
  }

  $state.go('fake-empty-state');
  window.gc();

  runProcedure(1);

  async function runProcedure(stamp) {
    $state.go(testingState);
    if (!$rootScope.$$phase) {
      $rootScope.$apply();
    }

    await timer(1000 * 2);
    $state.go('fake-empty-state');

    if (!$rootScope.$$phase) {
      $rootScope.$apply();
    }

    await timer(1000 * 1);
    window.gc();

    await timer(1000 * 1);
    console.timeStamp(`STAMP ${stamp}`);
    console.log(`%cSTAMP ${stamp}/4`, 'color: teal; font-size: 20px');

    if (stamp < 4) {
      runProcedure(stamp + 1);
    } else {
      $state.go(testingState);
      console.log('%c...done', 'color: magenta; font-size: 20px');
    }
  }
};
